import CardText from './card-text'
import { styled } from '@mui/system'

export const CardTextStyled = styled(CardText)``
